import { render, staticRenderFns } from "./Detail-Reservation.vue?vue&type=template&id=7a8670df&scoped=true"
import script from "./Detail-Reservation.vue?vue&type=script&lang=js"
export * from "./Detail-Reservation.vue?vue&type=script&lang=js"
import style0 from "./Detail-Reservation.vue?vue&type=style&index=0&id=7a8670df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8670df",
  null
  
)

export default component.exports